import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Heading } from "@/components/atoms/heading";
import { AdditionalFieldItem } from "@/components/molecules/additional-field/additional-field.item";
import { AvailabilitySlotList } from "@/components/molecules/availability-slot/availability-slot.list";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { useRevokePeriod } from "@/lib/backend/utils/hooks/use-revoke-period";

export function ProjectOverviewTab({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  const { getRevokePeriodText } = useRevokePeriod();

  const { data: additionalFields } = useQuery({
    queryKey: ["additionalFields", projectId],
    queryFn: () => extractionWrapper(api.additionalField.getAll(projectId)),
    enabled: !!projectId,
  });

  return (
    <div className="ion-padding flex flex-col gap-4">
      {!!additionalFields?.length && (
        <section>
          <div className="space-y-3">
            {additionalFields.map((field) => (
              <AdditionalFieldItem key={field.id} field={field} />
            ))}
          </div>
        </section>
      )}

      <section>
        <Heading order={2}>{t("common:availability-slots")}</Heading>
        <p className="mb-4 text-txt-secondary">
          {t("common:applications.deadline.description", {
            revokePeriodText: getRevokePeriodText(),
          })}
        </p>
        <AvailabilitySlotList projectId={projectId} showApplications={true} />
      </section>
    </div>
  );
}
